import { useSelector } from 'react-redux'
import { Typography, FlexBox } from '@vp/swan'
import { getProductName, getIGPL0Url } from '~/app/store/config/reducer'
import { useTranslations } from '~/app/features/Gallery/hooks/useTranslations'

export const IGPL0Callout = () => {
  const localize = useTranslations()
  const productName = useSelector(getProductName)
  const igpL0Url = useSelector(getIGPL0Url)

  const ariaLabel = localize('ProductPageIGPL0Label', { productname: productName }, { prefix: '{{', suffix: '}}' })
  const anchor = `<a href=${igpL0Url} aria-label=${ariaLabel}>${productName}</a>`
  const text = localize('ProductPageIGPL0Label', { productname: anchor }, { prefix: '{{', suffix: '}}' })

  return (
    <FlexBox justifyContent="center">
      <Typography component="p" dangerouslySetInnerHTML={{ __html: text }} margin="0" />
    </FlexBox>
  )
}

IGPL0Callout.displayName = 'IGPL0Callout'
